import PrinterNew from "pages/secure/facility/settings/printer/PrinterNew";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as UIActions from "redux/actions/ui";

const mapDispatchToProps = (dispatch: any) => {
  return {
    uiActions: bindActionCreators(
      {
        ...UIActions,
      },
      dispatch,
    ),
  };
};

const mapStateToProps = (state: any) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(PrinterNew);
